import React from 'react';
import { Connect } from './NotificationReadStatusContainer';

type Props = {
  isAlreadyRead: boolean;
};

export class RawNotificationReadStatus extends React.Component<Props> {
  render() {
    const { isAlreadyRead } = this.props;
    return (
      !isAlreadyRead && (
        <span
          className="notification-list__status"
          data-test-id="notification-unread-status"
        />
      )
    );
  }
}

export const NotificationReadStatus = Connect(RawNotificationReadStatus);
